export const SOCIAL_MEDIA_PROMOTION_REQUEST = "social-media-promotion-request";
